module.exports = __webpack_public_path__ + "804c06c94a8e0343cb3430656357f603.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/oracle_2024_chart.png
// module id = 1711
// module chunks = 0